import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as InfoIcon } from '../../assets/icons/svg/info.svg';
import '../../css/Common-components/infoButton.css';

// 작은 i 아이콘을 클릭하면 추가 정보를 포털로 띄우는 유틸 컴포넌트
function InfoButton({ children, offsetX = 0, offsetY = 0, placement = "bottom" }) {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const popupRef = useRef(null);
  const [positionTop, setPositionTop] = useState(0);
  const [positionLeft, setPositionLeft] = useState(0);

  // 버튼 클릭 시 전파를 막고 표시 상태를 토글한다.
  const togglePopup = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    // 팝업이 열릴 때마다 기준 버튼 위치를 계산해 화면에 맞게 위치시킨다.
    const updatePosition = () => {
      if (!isOpen || !buttonRef.current || !popupRef.current) return;
      const rect = buttonRef.current.getBoundingClientRect();
      const popupEl = popupRef.current;
      const sx = window.scrollX || window.pageXOffset;
      const sy = window.scrollY || window.pageYOffset;

      let top = 0;
      let left = 0;

      if (placement === "top") {
        top = rect.top + sy - popupEl.offsetHeight - offsetY;
        left = rect.left + sx + rect.width / 2 - popupEl.offsetWidth / 2 + offsetX;
      } else if (placement === "left") {
        top = rect.top + sy + (rect.height - popupEl.offsetHeight) / 2 + offsetY;
        left = rect.left + sx - popupEl.offsetWidth - offsetX;
      } else if (placement === "right") {
        top = rect.top + sy + (rect.height - popupEl.offsetHeight) / 2 + offsetY;
        left = rect.right + sx + offsetX;
      } else {
        top = rect.bottom + sy + offsetY;
        left = rect.left + sx + rect.width / 2 - popupEl.offsetWidth / 2 + offsetX;
      }

      const minLeft = sx + 8;
      const maxLeft = sx + window.innerWidth - popupEl.offsetWidth - 8;
      left = Math.max(minLeft, Math.min(left, maxLeft));

      setPositionTop(top);
      setPositionLeft(left);
    };

    updatePosition();

    if (isOpen) {
      window.addEventListener('resize', updatePosition);
      window.addEventListener('scroll', updatePosition, true);
    }
    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [isOpen, offsetX, offsetY, placement]);

  useEffect(() => {
    // 바깥 영역을 클릭하면 팝업을 닫는다.
    const handleClickOutside = (event) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="info-button-container" ref={buttonRef}>
      <button onClick={togglePopup} className="info-button btn" >
        <InfoIcon />
      </button>

      {isOpen &&
        ReactDOM.createPortal(
          // document.body 하위에 포털을 만들어 위치 계산이 쉬운 절대 좌표로 렌더링한다.
          <div
            ref={popupRef}
            className="info-popup"
            style={{
              position: 'absolute',
              top: `${positionTop}px`,
              left: `${positionLeft}px`
            }}
          >
            {children}
          </div>,
          document.body
        )}
    </div>
  );
}

export default InfoButton;
